import React, { useState } from 'react';
import CommonButton from '../../../../Components/CommonButton';
import CommonModal from '../../../../Components/CommonModal';
import { useConfirm } from '../../../../Components/ConfirmModal';
import Section from './Section';
import { risk_portal_add_comment, risk_portal_delete_comment } from '../../../../services';
import { Body, body, bodySmall } from '../../../../Constants/Fonts';
import { fmtDateTime } from './constants';

// CommentsSection — threaded notes on the risk: post + list + delete.
export default function CommentsSection({ riskId, detail, reload, notify }) {
    const [busy, setBusy] = useState(false);
    const [formKey, setFormKey] = useState(0);   // remount (clear) the form after posting
    const { confirm, confirmModal } = useConfirm();
    const comments = detail.comments || [];

    const run = async (fn, ok) => {
        setBusy(true);
        try { await fn(); if (ok) notify(ok, 'success'); await reload(); }
        catch (e) { notify(e?.response?.data?.error?.message || e?.message || 'Action failed', 'error'); }
        finally { setBusy(false); }
    };

    const post = (data) => {
        if (!data.text?.trim()) return;
        run(() => risk_portal_add_comment(riskId, { text: data.text.trim() }), 'Comment added').then(() => setFormKey((k) => k + 1));
    };
    const remove = async (c) => {
        const ok = await confirm({ title: 'Delete comment', message: 'Delete this comment?', confirmLabel: 'Delete', danger: true, themeColor: false });
        if (ok) run(() => risk_portal_delete_comment(c.id), 'Comment deleted');
    };

    return (
        <Section title="Comments" count={comments.length}>
            {/* Add-comment form — shared CommonModal rendered inline. */}
            <CommonModal
                inline
                key={formKey}
                title="Add Comment"
                fields={[{ name: 'text', label: 'Comment', type: 'textarea', rows: 2, placeholder: 'Add a comment…', required: true }]}
                defaultValues={{ text: '' }}
                onSubmit={post}
                buttons={[{ text: 'Post', variant: 'primary', type: 'submit', loading: busy, loadingText: 'Posting…' }]}
            />
            {comments.length === 0 ? (
                <p style={bodySmall({ color: 'var(--color-text-muted)', margin: '12px 0 0' })}>No comments yet.</p>
            ) : (
                <div className="rp1_comment_list">
                    {comments.map((c) => (
                        <div key={c.id} className="rp1_comment_item">
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                                <Body as="span" variant={2} color="var(--color-text-muted)">{c.author || c.created_by || ''} · {fmtDateTime(c.created_at)}</Body>
                                {c.id && <CommonButton variant="delete" text="×" onClick={() => remove(c)} disable={busy} />}
                            </div>
                            <p style={body({ color: 'var(--color-text-secondary)', margin: '4px 0 0' })}>{c.text}</p>
                        </div>
                    ))}
                </div>
            )}
            {confirmModal}
        </Section>
    );
}
